import { Map, LatLngLiteral } from 'leaflet';
import '../lib/leaflet.activearea';

export const alignMap = (
  map: Map,
  alignment: 'left' | 'right' | 'center',
  centerCoords: LatLngLiteral,
): void => {
  if (alignment === 'center') return;

  /* STEP 1: Set active area so that zoom goes into that specific area */
  // This is done using an npm that has no exports, you just import it (see top import 'leaflet-active-area')
  // eslint-disable-next-line
  // @ts-ignore No typings possible/available, see https://github.com/Mappy/Leaflet-active-area/tree/v1.2.1
  map.setActiveArea(
    {
      // Defining active area "box"
      position: 'absolute',
      top: 0,
      [alignment]: 0,
      height: '100%',
      width: `${map.getContainer().clientWidth - 750}px`,
    },
    false, // Keep center in middle of the map?
    true, // Use animations?
  );

  /* STEP 2: Move map to the left/right */
  map.setView(centerCoords, map.getZoom(), { animate: false });
};

/** Used to get center lat/lng literal of a polygon */
export const getCentroid = (arr: LatLngLiteral[]): LatLngLiteral => {
  return arr.reduce(
    (x, y) => {
      return {
        lat: x.lat + y.lat / arr.length,
        lng: x.lng + y.lng / arr.length,
      };
    },
    {
      lat: 0,
      lng: 0,
    },
  );
};
